import { SliderWithCommit } from "@/baseComponents";

import { useFilterContext } from "../FilterContext";

const FilterItemPoints = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();
  return (
    <div className="pt-[40px] pb-[12px] px-[40px]">
      <SliderWithCommit
        valueLabelDisplay="on"
        min={filterOptions.maxPointsRange[0] || 0}
        max={filterOptions.maxPointsRange[1] || 0}
        key={filterOptions.maxPointsRange[1] || 0}
        step={500}
        value={
          filterData.maxPoints === -1 ? filterOptions.maxPointsRange[1] || 0 : filterData.maxPoints
        }
        valueLabelFormat={(v: number) => `${v / 1000}K`}
        onChangeCommitted={(e, v) => {
          setFilterData({
            maxPoints: (v as number) === filterOptions.maxPointsRange[1] ? -1 : (v as number),
          });
        }}
      />
    </div>
  );
};

export default FilterItemPoints;
